import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * 共通エラー画面.
 */
@Component({
  selector: 'sun-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  /** HTTPステータスコード. */
  status: number;

  /** エラーメッセージ. */
  message: string;

  /**
   * コンストラクタ.
   *
   * @param activatedRoute ActivatedRoute
   */
  constructor(private activatedRoute: ActivatedRoute) { }

  /**
   * 初期処理.
   */
  ngOnInit() {

    // HTTPステータスコードを取得する
    this.status = +this.activatedRoute.snapshot.params['status'];
    if (isNaN(this.status)) {
      this.status = 500;
    }

    // HTTPステータスコードからエラーメッセージを選択する
    switch (this.status) {
      case 503:
        this.message = 'ただいまの時間は利用可能時間外です。';
        break;
      default:
        this.message = 'エラーが発生しました。しばらくしてからやり直してください。';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/component/error/error.component.ts